import { useMemo } from "react";
import { useAssetsStore } from "../store/use-assets-store";

interface UseAssetsOptions {
  searchTerm?: string;
  selectedAssetValue?: string;
}

export const useAssets = ({
  searchTerm = "",
  selectedAssetValue,
}: UseAssetsOptions = {}) => {
  const {
    assets,
    loading,
    error,
    getAssetByValue,
    isValidAsset,
    getFilteredAssets,
  } = useAssetsStore();

  const filteredAssets = useMemo(() => {
    return getFilteredAssets(searchTerm);
  }, [searchTerm, getFilteredAssets]);

  const selectedAsset = useMemo(() => {
    if (!selectedAssetValue) return undefined;
    return getAssetByValue(selectedAssetValue);
  }, [selectedAssetValue, getAssetByValue]);

  return {
    assets,
    filteredAssets,
    selectedAsset,
    getAssetByValue,
    isValidAsset,
    hasResults: filteredAssets.length > 0,
    loading,
    error,
  };
};
